const en = {
    // Navbar
    nav: {
        home: 'Home',
        features: 'Features',
        download: 'Download',
        premium: 'Premium',
        faq: 'FAQ',
        downloadNow: 'Download Now',
    },
    // Hero
    hero: {
        title: 'ShiguangJi,',
        subtitle: 'Your Smart Diet Assistant',
        description: 'ShiguangJi is an AI-powered health tracking app that uses visual recognition. Simply snap a photo of your food, and it instantly estimates calories and nutrition, helping you easily track every meal and manage your health goals scientifically.',
        newFeature: '✨ The all-new AI recognition engine is now live - more accurate, faster, and better understands Chinese cuisine!',
        appStoreDownload: 'Download on App Store',
        learnMore: 'Learn More',
        iosSupport: 'Supports iOS 16.0 and above',
        appleEcosystem: 'Apple Ecosystem Integration',
        aiRecognition: 'AI Smart Recognition',
    },
    // Features (Home)
    features: {
        title: 'Snap a Photo, Know All Nutrition',
        description: 'Powered by cutting-edge AI vision models, ShiguangJi can accurately recognize over 10,000+ Chinese and Western dishes. Simply take a photo, and it automatically estimates ingredient weight, calories, and key nutrients, making tedious diet tracking incredibly easy.',
        photoRecognition: 'Photo Recognition',
        calorieEstimation: 'Calorie Estimation',
        nutritionAnalysis: 'Nutrition Analysis',
        aiAdvisor: 'AI Nutrition Advisor',
        accuracyNote: '* Recognition accuracy may be affected by shooting angle and lighting. Data is for reference only.',
    },
    // Downloads
    downloads: {
        title: 'Get Started',
        mobileApp: 'Mobile App',
        ios: 'iOS',
        android: 'Android',
        directDownload: 'Download APK',
    },
    // FAQ
    faq: {
        title: 'FAQ',
        subtitle: 'Here are answers to some common questions.',
        contact: "Can't find what you're looking for? Contact us anytime through the feedback feature in the app.",
        questions: [
            { question: "How does ShiguangJi recognize food calories?", answer: "ShiguangJi integrates advanced AI vision model engines combined with an optimized Chinese food nutrition database. When you take a photo of food, the AI analyzes the food type and portion, then automatically matches the database to calculate calories and macronutrients for you." },
            { question: "What's the difference between guest mode and logging in?", answer: "Guest mode lets you experience basic recording features, but advanced features like AI photo recognition and AI nutrition advisor require you to sign in with your Apple ID for seamless use and secure cloud sync of your data." },
            { question: "How accurate is ShiguangJi's recognition?", answer: "Our AI engine has been trained on extensive Chinese and Western dishes, achieving industry-leading accuracy. However, factors like shooting angle, lighting, and hidden ingredients (like heavy oil or sugar in sauces) may cause some deviation. Data is for health reference only." },
            { question: "Is my data safe?", answer: "We take user privacy extremely seriously. Your diet records and photo data are stored in secure cloud databases powered by Supabase. We will never sell your personal data to third parties." },
            { question: "How do I cancel my premium subscription?", answer: "You can manage or cancel your ShiguangJi premium subscription anytime in your iOS device settings under 'Apple ID' > 'Subscriptions'." }
        ]
    },
    // Footer
    footer: {
        helpCenter: 'Help Center',
        sendFeedback: 'Send Feedback',
        contactEmail: 'Contact Email',
        product: 'Product',
        iosDownload: 'iOS Download',
        coreFeatures: 'Features',
        subscription: 'Subscription',
        support: 'Support',
        faq: 'FAQ',
        changelog: 'Changelog',
        contact: 'Contact Us',
        about: 'About',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        copyright: '© 2026 Andy Cao. All Rights Reserved.',
        wechat: 'WeChat',
        xiaohongshu: 'Xiaohongshu',
    },

    // Terms Page
    termsPage: {
        title: "Terms of Service",
        date: "Last Updated: Feb 22, 2026",
        toc: "Table of Contents",
        intro: "Welcome to ShiguangJi! This agreement outlines the terms of your use of our application.",
        s1: "1. Acceptance of Terms",
        s1p1: "By using this application, you confirm acceptance of these terms.",
        s1p2: "We reserve the right to modify these terms at any time.",
        s2: "2. Service Description",
        s2p1: "ShiguangJi is a health management tool providing:",
        s2i1: "AI Food Image Recognition",
        s2i2: "Diet Logging",
        s2i3: "Nutrition Analysis",
        s2i4: "AI Advisor",
        s2p2: "Data provided is not professional medical advice.",
        s3: "3. Account Security",
        s3p1: "An account may be required for certain features.",
        s3i1: "Provide accurate information.",
        s3i2: "Keep your account secure.",
        s3i3: "Notify us of any unauthorized use.",
        s3i4: "We are not liable for unauthorized access.",
        s3p2: "We may suspend abnormal accounts.",
        s4: "4. User Conduct",
        s4p1: "You agree not to:",
        s4i1: "Violate laws;",
        s4i2: "Infringe third-party rights;",
        s4i3: "Send spam;",
        s4i4: "Disrupt services;",
        s4i5: "Unauthorized access;",
        s4i6: "Scrape data.",
        s4p2: "Violation may result in account termination.",
        s5: "5. Subscription & Payment",
        s5p1: "Basic and Pro versions available.",
        s5p2: "Subscriptions auto-renew unless canceled 24h prior.",
        s5p3: "Refunds handled by Apple.",
        s6: "6. Intellectual Property",
        s6p1: "App copyright belongs to developers.",
        s6i1: "Do not modify or use code for commercial purposes.",
        s6i2: "You retain rights to your photos but grant us usage rights.",
        s6i3: "We respect intellectual property.",
        s6i4: "We may remove infringing content.",
        s6p2: "Feedback can be used freely.",
        s6p3: "Feedback is non-confidential.",
        s6note: "⚠️ We will remove infringing content upon notice.",
        s7: "7. Privacy",
        s7p1: "Refer to our Privacy Policy. Highlights:",
        s7i1: "Secure cloud database.",
        s7i2: "No selling to third parties.",
        s7i3: "Data deletion available on request.",
        s7i4: "Anonymous usage data collected.",
        s7p2: "Deleted accounts cannot be recovered.",
        s8: "8. Disclaimer",
        s8p1: "We are not liable for:",
        s8i1: "Non-medical advice.",
        s8i2: "Service interruptions.",
        s8i3: "Data loss.",
        s8i4: "Third-party services.",
        s8p2: "No liability for indirect damages.",
        s9: "9. Termination",
        s9p1: "We may terminate access anytime.",
        s9p2: "Liability limitations survive termination.",
        s10: "10. Governing Law",
        s10p1: "Governed by laws of PRC.",
        s10p2: "Disputes resolved in developer's local courts.",
        s11: "11. Contact",
        s11p1: "Contact us for issues:",
        footer: "You agree to be bound by these terms.",
        back: "← Back to Home",
    },

    // Privacy Page
    privacyPage: {
        title: "Privacy Policy",
        date: "Last Updated: Feb 22, 2026",
        intro: "Welcome to ShiguangJi! We value your privacy and data protection.",
        section1: "1. Information Collection",
        section1desc: "We only collect necessary info:",
        item1title: "Account Info:",
        item1desc: "Unique user identifier generated.",
        item2title: "Diet & Recognition Data:",
        item2desc: "Photos and nutrition data are stored.",
        item3title: "Device Data:",
        item3desc: "Crash logs and device models for troubleshooting.",
        section2: "2. Information Usage",
        section2desc1: "Provide core features.",
        section2desc2: "Never sell data to third parties.",
        section2desc3: "Anonymous data used to improve AI.",
        section3: "3. Storage & Security",
        section3p1: "Encrypted and stored in Supabase.",
        section3p2: "HTTPS used for all transmissions.",
        section31: "Third-party Services",
        section31p1: "Includes:",
        section31item1: "Supabase: Database.",
        section31item2: "OpenAI / Claude: Image recognition.",
        section31item3: "RevenueCat: Subscription management.",
        section31p2: "All subject to strict privacy policies.",
        section31p3: "Advance notice provided for data transfers.",
        section4: "4. Your Rights",
        section4item1: "Access right:",
        section4item1desc: "View and modify your data.",
        section4item2: "Deletion right:",
        section4item2desc: "Delete account permanently.",
        section4item3: "Revoke consent:",
        section4item3desc: "Revoke camera access from system settings.",
        section5: "5. Minors",
        section5desc: "Minors should use under supervision.",
        section6: "6. Updates",
        section6desc: "We will notify you of major changes.",
        section7: "7. Contact",
        section7desc: "Contact us for privacy concerns:",
        contactSite: "Official Site",
        footerNote: "By using our service, you agree to this Privacy Policy.",
        back: "← Back to Home",
    },

    featuresPage: {
        title: "Key Features",
        subtitle: "Explore the smart health management experience of ShiguangJi",
        aiRecognition: "AI Vision",
        f1Title: "Snap & Identify Everything",
        f1Desc: "Say goodbye to manual searches. Our advanced multi-modal model identifies any dish instantly.",
        f1List1: "Supports 10,000+ daily foods",
        f1List2: "Instant calorie & nutrition estimation",
        f1List3: "Specialized for Chinese cuisine",
        f1List4: "Manual portion adjustments",

        aiAdvisor: "AI Nutritionist",
        f2Title: "Your Pocket Advisor",
        f2Desc: "Get personalized health tips based on your logged history.",
        f2List1: "Diet structure analysis",
        f2List2: "Next meal recommendations",
        f2List3: "Ask any nutrition questions",
        f2List4: "Natural conversation experience",

        cloudSync: "Cloud Sync",
        f3Title: "Secure Multi-device Experience",
        f3Desc: "Records sync in seconds to the cloud.",
        f3List1: "Fast Apple ID login",
        f3List2: "End-to-end privacy encryption",
        f3List3: "Real-time sync across devices",
        f3List4: "Offline mode supported",

        premium: "Pro Features",
        f4Title: "Unlock Unlimited Potential",
        f4Desc: "Upgrade to Pro for the ultimate experience.",
        f4List1: "Unlimited AI visual recognition",
        f4List2: "Unlimited AI advisor chats",
        f4List3: "Advanced data trend analysis",
        f4List4: "One-click CSV data export",

        ctaTitle: "Ready for a Healthier Life?",
        ctaDesc: "Start hitting your goals intelligently with ShiguangJi.",
        downloadBtn: "Download for iOS",
        viewPlan: "View Plans"
    },

    changelogPage: {
        title: "Changelog",
        subtitle: "Track the growth and improvements of ShiguangJi",
        latest: "Latest",
        v100Date: "Mar 1, 2026",
        newFeatures: "New Features",
        feature1: "Upgraded to GPT-4o vision model, 40% accuracy boost!",
        feature2: "Redesigned 'Today's Diet' UI",
        feature3: "Launched 'Data Export' Pro feature",
        feature4: "Added Traditional Chinese and English support",
        feature5: "Added Apple ID secure login and cloud sync",
        improvements: "Improvements",
        improve1: "Boosted app cold-start speed",
        improve2: "Optimized Chinese food calorie estimations",
        improve3: "Refactored AI advisor interface",
        fixes: "Fixes",
        fix1: "Fixed spinning loader on weak networks",
        fix2: "Fixed text colors in Dark Mode",
        fix3: "Fixed time zone issues for logs",

        beta: "Beta",
        v090Date: "Feb 10, 2026",
        beta1: "Beta Release",
        beta2: "Core AI photo recognition",
        beta3: "Local data storage",
        beta4: "AI nutrition assistant",
        knownIssues: "Known Issues",
        issue1: "Cloud sync not yet supported",
        issue2: "Complex mixed plates may not identify accurately",

        ctaTitle: "Try the Latest Features",
        ctaDesc: "We iterate and optimize ShiguangJi every two weeks.",
        ctaButton: "Download on the App Store"
    },

    helpPage: {
        title: "Help Center",
        subtitle: "Have problems? Find answers here",
        category1: "FAQ",
        category1desc: "Answers to common usage questions",
        category2: "Subscription",
        category2desc: "Payment and membership questions",
        category3: "Features",
        category3desc: "Learn about core app features",
        category4: "Changelog",
        category4desc: "View latest feature updates",
        faqTitle: "Popular Questions",
        q1: "How to use AI recognition?",
        a1: "Tap the camera icon and snap a photo of food in good lighting.",
        q2: "Why is the recognition wrong?",
        a2: "Accuracy relies on lighting and angles. Data is for reference only.",
        q3: "How to switch languages?",
        a3: "Use the language button in the top right corner.",
        q4: "Does data sync?",
        a4: "Yes, automatically after logging in with Apple ID.",
        q5: "How to contact support?",
        a5: "Use the 'Send Feedback' button at the bottom of the page.",
        noAnswer: "Couldn't find the answer?",
        contactSubtitle: "Our support team is here to help",
        sendEmail: "Email Us",
        xiaohongshu: "Follow Xiaohongshu"
    },

    subscriptionPage: {
        title: "Premium Subscription",
        subtitle: "Choose the plan that fits you best",
        free: "Free",
        freePlan: "Basic",
        permanent: "/forever",
        freeDesc: "For light tracking",
        free1: "4 AI recognitions/day",
        free2: "4 AI chats/day",
        free3: "Basic diet logs",
        free4: "Local storage",
        free5: "Deep nutrition analysis",
        free6: "Advanced data export",
        free7: "Personalized memory",
        free8: "Priority support",
        freeUse: "Use for Free",

        recommended: "Recommended",
        mostPopular: "Most Popular",
        monthlyPlan: "Monthly",
        perMonth: "/mo",
        monthlyDesc: "For daily users",
        monthly1: "Unlimited AI recognitions",
        monthly2: "Unlimited AI chats",
        monthly3: "Full diet logs",
        monthly4: "Cloud Sync",
        monthly5: "Deep nutrition analysis",
        monthly6: "Advanced data export",
        monthly7: "Personalized memory",
        monthly8: "Priority support",
        subscribeNow: "Subscribe Now",

        bestValue: "Best Value",
        annualPlan: "Annual",
        perYear: "/yr",
        annualDesc: "Equals ¥8.25/mo",
        annual1: "Unlimited AI recognitions",
        annual2: "Unlimited AI chats",
        annual3: "Full diet logs",
        annual4: "Cloud Sync",
        annual5: "Deep nutrition analysis",
        annual6: "Advanced data export",
        annual7: "Personalized memory",
        annual8: "Priority support",
        annual9: "Exclusive themes",

        faqTitle: "Subscription FAQ",
        q1: "How to subscribe?",
        a1: "Click the button to open the App Store and subscribe in-app.",
        q2: "Free vs Paid?",
        a2: "Free version has daily limits. Pro gives unlimited access and advanced tools.",
        q3: "How to cancel?",
        a3: "Manage in iOS Settings > Apple ID > Subscriptions.",
        q4: "Can I get a refund?",
        a4: "Refunds are governed by Apple App Store policies.",
        note: "💡 Subscriptions auto-renew. Cancel at least 24 hours before expiration to avoid charges."
    }
};

export default en;
